/**
 * Routing, in thirty lines and no dependency.
 *
 * There are exactly two screens: the library, and one open book. A router that
 * can express more than that would be more machinery than the app has need of.
 */

import { useEffect, useState } from "react";

export type Route = { name: "library" } | { name: "book"; id: string };

export function parse(hash: string): Route {
  const match = /^#\/book\/(.+)$/.exec(hash);
  return match ? { name: "book", id: decodeURIComponent(match[1]) } : { name: "library" };
}

export function href(route: Route): string {
  return route.name === "book" ? `#/book/${encodeURIComponent(route.id)}` : "#/";
}

export function navigate(route: Route): void {
  location.hash = href(route);
}

export function useRoute(): Route {
  const [route, setRoute] = useState<Route>(() => parse(location.hash));
  useEffect(() => {
    const update = () => setRoute(parse(location.hash));
    window.addEventListener("hashchange", update);
    return () => window.removeEventListener("hashchange", update);
  }, []);
  return route;
}
